// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as Turbo from "@hotwired/turbo"
import "./controllers"

window.Turbo = Turbo
